const SEQUENCE_CONFIG = [
  { prefix: '00001000', totalFrames: 31, startIndex: 1, padLen: 2 },
  { prefix: 'ComfyUI_', totalFrames: 33, startIndex: 1, padLen: 6 },
  { prefix: '000010001_', totalFrames: 31, startIndex: 0, padLen: 5 },
];

export const FRAME_RATE = 30;
export const PLAYBACK_RATE = 0.3;
export const FRAME_DURATION = 1000 / FRAME_RATE / PLAYBACK_RATE;

function getSortedFrames(
  frames: Record<string, string>,
  prefix: string,
  totalFrames: number,
  startIndex: number,
  padLen: number,
): string[] {
  const frameArray: string[] = [];
  for (let i = 0; i < totalFrames; i++) {
    const frameNumber = startIndex + i;
    const paddedNumber = String(frameNumber).padStart(padLen, '0');
    const fileName = `${prefix}${paddedNumber}.png`;
    const matchedKey = Object.keys(frames).find((k) => k.endsWith(fileName));
    if (matchedKey && frames[matchedKey]) {
      frameArray.push(frames[matchedKey] as string);
    }
  }
  return frameArray;
}

const card1Frames = (import.meta as any).glob(
  '/src/assets/home/screen5-sequence-frames/card1/*.png',
  { eager: true, import: 'default' },
) as Record<string, string>;
const card2Frames = (import.meta as any).glob(
  '/src/assets/home/screen5-sequence-frames/card2/*.png',
  { eager: true, import: 'default' },
) as Record<string, string>;
const card3Frames = (import.meta as any).glob(
  '/src/assets/home/screen5-sequence-frames/card3/*.png',
  { eager: true, import: 'default' },
) as Record<string, string>;

const rawFrames = [card1Frames, card2Frames, card3Frames];

export const CARD_FRAMES: string[][] = SEQUENCE_CONFIG.map((cfg, i) =>
  getSortedFrames(rawFrames[i], cfg.prefix, cfg.totalFrames, cfg.startIndex, cfg.padLen),
);
